var aTag = $('a');
//戻るボタン
aTag.on('click',function(){
  var target = false;
  if($(this).attr('href').match(/#/) != -1) target = $('#' + $(this).attr('href').split('#')[1]);
  if(target != false){
    $('html,body').animate({scrollTop:target.offset().top}, 700);
  }
});
